import { render, staticRenderFns } from "./pagemanagement.vue?vue&type=template&id=4bf4e9f4&scoped=true&"
import script from "./pagemanagement.vue?vue&type=script&lang=js&"
export * from "./pagemanagement.vue?vue&type=script&lang=js&"
import style0 from "./pagemanagement.vue?vue&type=style&index=0&id=4bf4e9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4e9f4",
  null
  
)

export default component.exports